(function() {
    'use strict';
    angular
        .module('uniromaLandingApp')
        .factory('Service_tr', Service_tr);

    Service_tr.$inject = ['$resource'];

    function Service_tr ($resource) {
        var resourceUrl =  'api/service-trs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
